import { xsmall, small, normal, large } from './sizes';
export default {
  [xsmall]: 'btnXSmallLineHeight',
  [small]: 'btnSmallLineHeight',
  [normal]: 'btnLineHeight',
  [large]: 'btnLargeLineHeight'
};
//# sourceMappingURL=icon-sizes.js.map